// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteAppSystemRequestModel from '../../model/delete-app-system-request-model';
import DeleteAppSystemRequestDTO from '../dto/delete-app-system-request-dto';
import dtoSchema from '../schemas/delete-app-system-request-schema';

export default abstract class DeleteAppSystemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteAppSystemRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteAppSystemRequestDTO>): DeleteAppSystemRequestModel;
  static toModel(dto: DeepPartial<DeleteAppSystemRequestDTO> | undefined | null): DeleteAppSystemRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteAppSystemRequestDTO> | undefined | null): DeleteAppSystemRequestModel | undefined {
    return dto ? new DeleteAppSystemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteAppSystemRequestModel> | DeleteAppSystemRequestModel): DeleteAppSystemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteAppSystemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteAppSystemRequestModel, can not map to DeleteAppSystemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
